import { Attrs, EventListeners, MinzeElement } from 'minze'
import { Locale } from '../../modules/locale'
import MainModule from '../../modules/main'
import { LvcPrimarySliderItem } from '../../modules/sliderUtils'

Locale.getInstance().registerKeySet('fr', 'lvc-event-ticket', {
  ticket: 'Billets',
  free: 'Gratuit',
})
Locale.getInstance().registerKeySet('en', 'lvc-event-ticket', {
  ticket: 'Tickets',
  free: 'Free',
})

export interface LvcEventTicket {
  href: string
  target: string
  dataComponentLocation: string
  isFree: boolean
  eventId: string
  eventData: string
}
export class LvcEventTicket extends MinzeElement {
  attrs: Attrs = [
    ['href', '#'],
    'data-component-location',
    ['target', '_blank'],
    'is-free',
    'event-id',
    ['event-data', ''],
  ]

  user: object | null = null
  mainModule = MainModule.getInstance()

  async onReady(): Promise<void> {
    try {
      setTimeout(async () => {
        // Retrieve user data
        this.user = await this.mainModule.getAuth().loadProfile()
      }, 200)
    } catch (error) {
      console.error('Error fetching user data:', error)
    }
  }

  handleClick = async (event: Event) => {
    event.preventDefault()

    // Likely extract to helper function as this will be used in multiple places
    // Check the favorites button for similar logic ??
    try {
      const mainModule = MainModule.getInstance()
      const parsedEventData: LvcPrimarySliderItem = this.eventData
        ? JSON.parse(decodeURIComponent(this.eventData))
        : {}
      if (parsedEventData) {
        const eventName = parsedEventData.name?.[Locale.language] || parsedEventData.name?.fr || ''
        const eventLocation =
          parsedEventData.location?.[Locale.language] || parsedEventData.location?.fr || ''
        const eventDate = parsedEventData.formattedDateTime || ''
        const eventCategory = Array.isArray(parsedEventData.uiAdditionalTypes)
          ? parsedEventData.uiAdditionalTypes.map(type => type.code).join(', ')
          : ''
        const eventArtist =
          parsedEventData.artist?.[Locale.language] || parsedEventData.artist?.fr || ''
        const eventId = parsedEventData.id || this.eventId || ''
        if (this.href) {
          if (this.isFree) {
            await mainModule.analyticsTrack('cta_gratuit', {
              nom: eventName,
              id_evenement: eventId,
              type: eventCategory,
              event_location: eventLocation,
              date: eventDate,
              artiste: eventArtist,
              emplacement: this.dataComponentLocation || '',
            })
          } else {
            await mainModule.analyticsTrack('add_to_cart', {
              ecommerce: {
                items: [
                  {
                    item_name: eventName,
                    item_id: eventId,
                    item_brand: eventArtist,
                    item_category: eventCategory,
                    item_category2: eventLocation,
                    item_category3: eventDate,
                    item_category4: 'billet',
                    emplacement: this.dataComponentLocation || '',
                  },
                ],
              },
            })
          }
        }
      }
    } catch (err) {
      console.error('Error tracking event:', err)
    }

    try {
      //@ts-ignore
      fbq('track', 'AddToCart', {
        ticket_url: this.href || '',
        state: this.isFree ? 'gratuit' : 'billet',
        emplacement: this.dataComponentLocation || '',
      })
    } catch (err) {
      console.log('Error sending Facebook Pixel event:', err)
    }

    try {
      if (this.eventId) {
        window.algoliaInsights?.('convertedObjectIDs', {
          eventName: 'Ticket Button Clicked',
          index: 'events_search',
          objectIDs: [`eventOffers-${this.eventId}`],
          authenticatedUserToken: (this.user as { id: string })?.id || '',
        })
      }
    } catch (err) {
      console.error('Error sending Algolia insights:', err)
    }

    window.open(this.href, this.target, 'noreferrer')
  }
  html = () => /*html*/ `
    <a href="${this.href}" rel="noopener noreferrer">
      <lvc-ticket-icon></lvc-ticket-icon>
      <div class="label">${this.isFree ? `${Locale.getKey('lvc-event-ticket.free')}` : `${Locale.getKey('lvc-event-ticket.ticket')}`}</div>
    </a>
  `
  css = () => `
    lvc-ticket-icon {
      height: 28px;
      width: 28px;
      color: #FF4600;
    }
    :host {
      display: inline-flex;
      border-radius: 999px;
      background: linear-gradient(100deg, #FFFFFF 5%, #BFF0FF 148.15%);
      background-size: 300%;
      font-size: 12px;
      cursor: pointer;
      transition: background 0.2s ease;
    }
    :host(:hover) {
      background-size: 100%;
    }
    a {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 35px;
      padding: 0 16px;
      gap: 4px;
      text-decoration: none;
      color: #1E007D;
    }
    .label {
      text-wrap: nowrap;
      margin-right: 8px;
    }
    
  `
  eventListeners: EventListeners = [[this, 'click', this.handleClick]]
}
